import { css } from '@linaria/core';
import { theming } from 'styles/utils/core';
export const thumbWrapper = "omponents__Canvas__RegionThumb__RegionThumb_styles_ts-thumbWrapper-t1ab617u";
export const regionIcon = "omponents__Canvas__RegionThumb__RegionThumb_styles_ts-regionIcon-ru1i895";

require("./RegionThumb.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./RegionThumb.styles.ts");